'use client'

import { RefObject, useEffect } from 'react'

/**
 * Escape on a `showModal()` dialog fires a `cancel` event and closes instantly. Intercept it so
 * the close is routed through `onClose` (and can animate out) instead of popping shut.
 * `mountTrigger` re-attaches the listener when the (animated) dialog element (un)mounts.
 */
export const useCancelToClose = (
    dialogRef: RefObject<HTMLDialogElement>,
    onClose: () => void,
    mountTrigger?: boolean,
) => {
    useEffect(() => {
        const dialog = dialogRef.current
        if (!dialog) return

        const handleCancel = (event: Event) => {
            event.preventDefault()
            onClose()
        }
        dialog.addEventListener('cancel', handleCancel)
        return () => dialog.removeEventListener('cancel', handleCancel)
    }, [dialogRef, onClose, mountTrigger])
}
